import * as React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface RoundedIconButtonProps extends Omit<ButtonProps, "size"> {
  size?: "sm" | "md" | "lg";
  floating?: boolean;
  badge?: React.ReactNode;
}

const sizeClasses = {
  sm: "h-10 w-10",
  md: "h-12 w-12",
  lg: "h-14 w-14",
};

const iconSizeClasses = {
  sm: "[&>svg]:h-4 [&>svg]:w-4",
  md: "[&>svg]:h-5 [&>svg]:w-5",
  lg: "[&>svg]:h-6 [&>svg]:w-6",
};

export const RoundedIconButton = React.forwardRef<
  HTMLButtonElement,
  RoundedIconButtonProps
>(
  (
    { className, size = "md", floating = false, badge, children, ...props },
    ref,
  ) => {
    const floatingClasses = floating ? "fixed bottom-16 right-6 z-40" : "";

    return (
      <div className={cn("relative inline-block", floatingClasses)}>
        <Button
          ref={ref}
          size="icon"
          className={cn(
            sizeClasses[size],
            iconSizeClasses[size],
            "rounded-full shrink-0",
            floating && "shadow-lg",
            className,
          )}
          {...props}
        >
          {children}
        </Button>
        {badge}
      </div>
    );
  },
);

RoundedIconButton.displayName = "RoundedIconButton";
